import {
  Component,
  effect,
  inject,
  OnDestroy,
  OnInit,
  signal,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationTemplate } from '../notification-template/notification-template';
import { AddEmail } from '../add-email/add-email';

/*** imports for table filters components ***/
import { TableComponent } from '../../shared/tablefilters/table/table.component';
import { TableFilterService } from '../../shared/tablefilters/table-filter.service';
import { Column } from '../../shared/tablefilters/column.model';
import { TableDetails } from '../../shared/tablefilters/table-details.model';
import { of, Subject, Subscription, takeUntil } from 'rxjs';
import { CommonService, Exception, ToasterService } from '@anddone/ui-utilities';
import { AllyCommonService } from '../../../../../services/ally-common-service';
import { Notification } from '../../../../../services/notification';
import { MessageConstants } from '../../../../../constants/message.constant';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-find-notifications',
  imports: [TableComponent, TranslateModule, CommonModule],
  templateUrl: './find-notifications.html',
  styleUrl: './find-notifications.scss',
  providers: [DatePipe],
})
export class FindNotifications implements OnInit, OnDestroy {
  @ViewChild('pauseAllModal') pauseAllModal!: TemplateRef<any>;
  @ViewChild('unpauseAllModal') unpauseAllModal!: TemplateRef<any>;
  @ViewChild('noEmailsModal') noEmailsModal!: TemplateRef<any>;
  viewTemplateModalRef: any;

  /*** Local variables needed for table filter system ***/
  searchParamsData: any = {};
  pager: any = {};
  tableActionSub!: Subscription;
  searchInputSub!: Subscription;
  private destroy$ = new Subject<void>();
  notificationList: any = [];
  tableDetails: any = {};
  @ViewChild('toggleCell', { static: true })
  toggleCell!: TemplateRef<any>;
  @ViewChild('templateCell', { static: true })
  templateCell!: TemplateRef<any>;
  isPauseAll = false;
  isPauseAllDisabled = signal(false);

  // merchantTable: TableDetails = {
  //   tableId: 'find-merchant-notifications-table',
  //   searchPlaceholder: 'Event Name',
  //   allowRowClick: true,
  //   rowClickURI: '/ally/notifications/details',
  //   tableTitle: 'Merchant Notifications',
  //   defaultItemPerPage: 10,
  //   sendDefault90DayFilter: false,
  // };

  // merchantColumns: Column[] = [
  //   { name: 'Event Name', sortState: 'none', isSortable: true, display: 'normal', responseKey: 'eventName', requestKey: 'eventName',
  //     filter: {
  //       type: 'string',
  //       validation: ['required']
  //     },
  //   },
  //   { name: 'Event Type', sortState: 'none', isSortable: false, display: 'normal', responseKey: 'eventType', requestKey: 'eventTypes',
  //     filter:  {
  //       type: 'multipleChoice',
  //       options: [
  //         { label: 'Report', key:'Report', checked: false },
  //         { label: 'Transaction', key:'Transaction', checked: false },
  //         { label: 'User', key:'User', checked: false },
  //         { label: 'Support', key:'Support', checked: false },
  //       ],
  //     },
  //   },
  //   // TODO: Make custom template to display 'Emails:' prefix on column
  //   { name: 'Distribution List Count', sortState: 'none', isSortable: true, display: 'normal', responseKey: 'distributionList.emailCount', requestKey: null,
  //     filter: null,
  //   },
  //   // TODO: Make custom template to add button to display email wysiwyg modal
  //   { name: 'Email Template', sortState: 'none', isSortable: false, display: 'template', responseKey: 'emailTemplates', requestKey: null,
  //     filter: null, cellTemplate: this.templateCell
  //   },
  //   // TODO: Make custom template for status toggle element
  //   { name: 'Status', sortState: 'none', isSortable: false, display: 'normal', responseKey: 'status', requestKey: 'statuses',
  //     filter: {
  //       type: 'multipleChoice',
  //       options: [
  //         { label: 'Enabled', key:'Active', checked: false },
  //         { label: 'Disabled', key:'Inactive', checked: false }
  //       ],
  //     },
  //   },
  // ];

  shopperTable: TableDetails = {
    tableId: 'find-shopper-notifications-table',
    searchPlaceholder: 'Event Name',
    allowRowClick: true,
    rowClickURI: '/ally/notifications/details',
    tableTitle: 'Shopper Notifications',
    defaultItemPerPage: 10,
    sendDefault90DayFilter: false,
  };

  shopperColumns: Column[] = [
    {
      name: 'Event Name',
      sortState: 'none',
      isSortable: true,
      display: 'normal',
      responseKey: 'eventName',
      requestKey: 'eventName',
      filter: {
        type: 'string',
        validation: ['required'],
      },
    },
    {
      name: 'Event Type',
      sortState: 'none',
      isSortable: false,
      display: 'normal',
      responseKey: 'eventType',
      requestKey: 'eventTypes',
      filter: {
        type: 'multipleChoice',
        options: [
          { label: 'Report', key: 'Report', checked: false },
          { label: 'Transaction', key: 'Transaction', checked: false },
          { label: 'User', key: 'User', checked: false },
          { label: 'Support', key: 'Support', checked: false },
        ],
      },
    },
    // TODO: Make custom template to add button to display email wysiwyg modal
    {
      name: 'Email Template',
      sortState: 'none',
      isSortable: false,
      display: 'template',
      responseKey: 'emailTemplates',
      requestKey: null,
      filter: undefined,
      cellTemplate: this.templateCell,
    },
    {
      name: 'Status',
      sortState: 'none',
      isSortable: false,
      display: 'template',
      responseKey: 'status',
      requestKey: 'statuses',
      cellTemplate: this.toggleCell,
      filter: {
        type: 'multipleChoice',
        options: [
          { label: 'Enabled', key: 'Active', checked: false },
          { label: 'Disabled', key: 'Inactive', checked: false },
        ],
      },
    },
  ];

  platformTable: TableDetails = {
    tableId: 'find-platform-notifications-table',
    searchPlaceholder: 'Event Name',
    allowRowClick: true,
    rowClickURI: '/ally/notifications/details',
    tableTitle: 'Platform Notifications',
    defaultItemPerPage: 10,
    sendDefault90DayFilter: false,
  };

  platformColumns: Column[] = [
    {
      name: 'Event Name',
      sortState: 'none',
      isSortable: true,
      display: 'normal',
      responseKey: 'eventName',
      requestKey: 'eventName',
      filter: {
        type: 'string',
        validation: ['required'],
      },
    },
    {
      name: 'Event Type',
      sortState: 'none',
      isSortable: false,
      display: 'normal',
      responseKey: 'eventType',
      requestKey: 'eventTypes',
      filter: {
        type: 'multipleChoice',
        options: [
          { label: 'Support', key: 'Support', checked: false },
          { label: 'Invoice', key: 'Invoice', checked: false },
        ],
      },
    },
    // TODO: Make custom template to add button to display email wysiwyg modal
    {
      name: 'Email Template',
      sortState: 'none',
      isSortable: false,
      display: 'template',
      responseKey: 'emailTemplates',
      requestKey: null,
      filter: undefined,
      cellTemplate: this.templateCell,
    },
  ];

  allyTable: TableDetails = {
    tableId: 'find-ally-notifications-table',
    searchPlaceholder: 'Event Name',
    allowRowClick: true,
    rowClickURI: '/ally/notifications/details',
    tableTitle: 'Ally Notifications',
    defaultItemPerPage: 10,
    sendDefault90DayFilter: false,
  };

  allyColumns: Column[] = [
    {
      name: 'Event Name',
      sortState: 'asc',
      isSortable: true,
      display: 'normal',
      responseKey: 'eventName',
      requestKey: 'eventName',
      filter: {
        type: 'string',
        validation: ['required'],
      },
    },
    {
      name: 'Event Type',
      sortState: 'none',
      isSortable: false,
      display: 'normal',
      responseKey: 'eventType',
      requestKey: 'eventTypes',
      filter: {
        type: 'multipleChoice',
        options: [{ label: 'Maintenance', key: 'Maintenance', checked: false }],
      },
    },
    // TODO: Make custom template to display 'Emails:' prefix on column
    {
      name: 'Distribution List Count',
      sortState: 'none',
      isSortable: true,
      display: 'normal',
      responseKey: 'distributionListCount',
      requestKey: 'distributionListCount',
      filter: undefined,
    },
    {
      name: 'Status',
      sortState: 'none',
      isSortable: false,
      display: 'template',
      responseKey: 'status',
      requestKey: 'statuses',
      cellTemplate: this.toggleCell,
      filter: {
        type: 'multipleChoice',
        options: [
          { label: 'Enabled', key: 'Active', checked: false },
          { label: 'Disabled', key: 'Inactive', checked: false },
        ],
      },
    },
  ];

  systemTable: TableDetails = {
    tableId: 'find-system-notifications-table',
    searchPlaceholder: 'Event Name',
    allowRowClick: true,
    rowClickURI: '/ally/notifications/details',
    tableTitle: 'System Notifications',
    defaultItemPerPage: 10,
    sendDefault90DayFilter: false,
  };

  systemColumns: Column[] = [
    {
      name: 'Event Name',
      sortState: 'none',
      isSortable: true,
      display: 'normal',
      responseKey: 'eventName',
      requestKey: 'eventName',
      filter: {
        type: 'string',
        validation: ['required'],
      },
    },
    {
      name: 'Event Type',
      sortState: 'none',
      isSortable: false,
      display: 'normal',
      responseKey: 'eventType',
      requestKey: 'eventTypes',
      filter: {
        type: 'multipleChoice',
        options: [{ label: 'Maintenance', key: 'Maintenance', checked: false }],
      },
    },
    // TODO: Make custom template to display 'Emails:' prefix on column
    {
      name: 'Distribution List Count',
      sortState: 'none',
      isSortable: true,
      display: 'normal',
      responseKey: 'distributionListCount',
      requestKey: null,
      filter: undefined,
    },
    {
      name: 'Status',
      sortState: 'none',
      isSortable: false,
      display: 'template',
      responseKey: 'status',
      requestKey: 'statuses',
      cellTemplate: this.toggleCell,
      filter: {
        type: 'multipleChoice',
        options: [
          { label: 'Enabled', key: 'Active', checked: false },
          { label: 'Disabled', key: 'Inactive', checked: false },
        ],
      },
    },
  ];

  tabs = [
    // {id: 'merchant-notifications', label: 'Merchant', tableDetails: this.merchantTable, columns: this.merchantColumns },
    {
      id: 'ally-notifications',
      label: 'Ally',
      tableDetails: this.allyTable,
      columns: this.allyColumns,
    },
    {
      id: 'shopper-notifications',
      label: 'Shopper',
      tableDetails: this.shopperTable,
      columns: this.shopperColumns,
    },
    {
      id: 'platform-notifications',
      label: 'Platform',
      tableDetails: this.platformTable,
      columns: this.platformColumns,
    },
    {
      id: 'system-notifications',
      label: 'System',
      tableDetails: this.systemTable,
      columns: this.systemColumns,
    },
  ];

  activeTabId = 'ally-notifications';
  public commonService = inject(CommonService);
  public allyCommonService = inject(AllyCommonService);
  private toasterService = inject(ToasterService);
  private tableFilterService = inject(TableFilterService);
  private notificationService = inject(Notification);
  private modalService = inject(NgbModal);
  constructor() {
    effect(() => {
      const emailAddedCount = this.notificationService.emailAdded();
      const emailUpdatedCount = this.notificationService.emailUpdated();
      if (emailAddedCount > 0 || emailUpdatedCount > 0) {
        this.findNotifications(this.pager.currentPage, this.activeTabId);
      }
    });
  }

  ngOnInit(): void {
    /*** Table Filter subscriptions ***/
    this.tableFilterService.init(this.tabs[0].columns, this.tabs[0].tableDetails);

    // this.tableActionSub = this.tableFilterService.tableActionEvent.pipe(takeUntil(this.destroy$)).subscribe((operationObject) => {
    //   this.onTransactionOperationClick(operationObject.operation, operationObject.row);
    // });

    this.searchInputSub = this.tableFilterService.searchInput
      .pipe(takeUntil(this.destroy$))
      .subscribe((searchInput) => {
        this.searchParamsData = searchInput.searchParams;
        this.pager = searchInput.pager;
        /*** Assign the method that manages your API call here. ***/
        this.findNotifications(this.pager.currentPage, this.activeTabId);
      });

    this.tableFilterService.registerSubscriptions(this.searchInputSub, this.tableActionSub);
    const col = this.tabs[0].columns.find((c) => c.responseKey === 'status');
    if (col) col.cellTemplate = this.toggleCell;
    const templateCol = this.tabs[0].columns.find((c) => c.responseKey === 'emailTemplates');
    if (templateCol) templateCol.cellTemplate = this.templateCell;
  }

  findNotifications(pageNumber: number, notificationType: string) {
    this.allyCommonService.setIsLoader(true);
    this.searchParamsData = this.tableFilterService.prepareSearchParamsForAPICall(pageNumber);
    this.tableDetails = this.getTableDetailsBasedOnActiveTab(notificationType);
    const reqObj = this.searchParamsData;
    reqObj.NotificationType = this.getNotificationTypeBasedOnActiveTab(notificationType);

    this.notificationService
      .getAllNotifications(reqObj)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (notificationType !== this.activeTabId) {
            return;
          }
          this.tableFilterService.setPager(res, pageNumber, this.pager);
          if (res.data.length > 0) {
            res.data.forEach((ele: any) => {
              ele.distributionListCount =
                ele.distributionList && ele.distributionList.emailCount
                  ? 'Emails: ' + ele.distributionList.emailCount
                  : 'Emails: 0';
            });
            this.notificationList = res.data;
            const pauseCount = this.notificationList.filter((x: any) => x.isPaused == true);
            this.isPauseAll = pauseCount?.length > 0 ? true : false;

            if (!this.isPauseAll) {
              const isActiveCount = this.notificationList.filter(
                (x: any) => x.status?.toLowerCase() == 'active'
              );
              if (isActiveCount?.length > 0) {
                this.isPauseAllDisabled.set(false);
              } else {
                this.isPauseAllDisabled.set(true);
              }
            }
            this.tableDetails.tableData = this.notificationList || [];
            this.tableFilterService.setTableDetails(this.tableDetails);
          } else {
            this.notificationList = [];
            this.tableDetails.tableData = [];
            this.tableFilterService.setTableDetails(this.tableDetails);
          }
          this.allyCommonService.setIsLoader(false);
        },
        error: (e) => {
          this.allyCommonService.setIsLoader(false);
          const toastMessage = Exception.exceptionMessage(e);
          this.toasterService.showError(toastMessage.join(', '), 'full');
        },
      });
  }

  changeActiveTable(tabId: string) {
    this.activeTabId = tabId;
    this.tableFilterService.clearFilters();
    let tabIndex;
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].id == tabId) {
        tabIndex = i;
      }
    }

    this.tableFilterService.init(this.tabs[tabIndex!].columns, this.tabs[tabIndex!].tableDetails);

    this.searchInputSub = this.tableFilterService.searchInput
      .pipe(takeUntil(this.destroy$))
      .subscribe((searchInput) => {
        this.searchParamsData = searchInput.searchParams;
        this.pager = searchInput.pager;
        this.findNotifications(this.pager.currentPage, this.activeTabId);
      });
    this.tableFilterService.registerSubscriptions(this.searchInputSub, this.tableActionSub);
  }

  handlePauseClick() {
    if (this.isPauseAll) {
      this.modalService.open(this.unpauseAllModal);
    } else {
      this.modalService.open(this.pauseAllModal);
    }
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  viewTemplate(event: Event) {
    event.stopPropagation();
    this.viewTemplateModalRef = this.modalService.open(NotificationTemplate, { scrollable: true });
  }

  openDistributionListModal() {
    this.closeModal();
    this.modalService.open(AddEmail);
  }

  pauseUnpauseAllNotification(type: any) {
    if (type == 'pause') {
      this.isPauseAll = true;
    } else {
      this.isPauseAll = false;
    }
    this.closeModal();
    this.allyCommonService.setIsLoader(true);
    const obj = {
      status: type == 'pause' ? 'Paused' : 'Active',
    };
    this.notificationService.pauseUnpauseAllNotification(obj).subscribe({
      next: () => {
        this.isPauseAll = type == 'pause' ? true : false;
        this.allyCommonService.setIsLoader(false);
        this.findNotifications(this.pager.currentPage, this.activeTabId);
        const successMsg =
          type == 'pause'
            ? MessageConstants.notification.paused
            : MessageConstants.notification.unpaused;
        this.toasterService.showSuccess(successMsg, 'full');
      },
      error: (e) => {
        this.allyCommonService.setIsLoader(false);
        const toastMessage = Exception.exceptionMessage(e);
        this.toasterService.showError(toastMessage.join(', '), 'full');
      },
    });
  }

  getNotificationTypeBasedOnActiveTab(notificationType: string) {
    switch (notificationType) {
      case 'ally-notifications':
        return 'Ally';
      case 'shopper-notifications':
        return 'Shopper';
      case 'platform-notifications':
        return 'Platform';
      case 'system-notifications':
        return 'System';
    }

    return of(null);
  }

  getTableDetailsBasedOnActiveTab(notificationType: string) {
    switch (notificationType) {
      case 'ally-notifications':
        return this.allyTable;
      case 'shopper-notifications':
        return this.shopperTable;
      case 'platform-notifications':
        return this.platformTable;
      case 'system-notifications':
        return this.systemTable;
    }
    return of(null);
  }

  subscribeDefaultNotification(item: any) {
    this.allyCommonService.setIsLoader(true);
    this.notificationService.subscribeDefaultNotification(item?.id).subscribe({
      next: () => {
        this.allyCommonService.setIsLoader(false);
        this.findNotifications(this.pager.currentPage, this.activeTabId);
        this.toasterService.showSuccess(MessageConstants.notification.subscribed, 'full');
      },
      error: (e: any) => {
        this.allyCommonService.setIsLoader(false);
        const toastMessage = Exception.exceptionMessage(e);
        this.toasterService.showError(toastMessage.join(', '), 'full');
      },
    });
  }

  subscribeAllyNotification(item: any) {
    this.allyCommonService.setIsLoader(true);
    const obj = {
      status: item?.status == 'Active' ? 'InActive' : 'Active',
    };
    this.notificationService.subscribeAllyNotification(item?.id, obj).subscribe({
      next: () => {
        this.allyCommonService.setIsLoader(false);
        if (item?.status?.toLowerCase() == 'inactive') {
          this.toasterService.showSuccess(MessageConstants.notification.subscribed, 'full');
        } else if (item?.status?.toLowerCase() == 'active') {
          this.toasterService.showSuccess(MessageConstants.notification.unsubscribed, 'full');
        }
        this.findNotifications(this.pager.currentPage, this.activeTabId);
      },
      error: (e) => {
        this.allyCommonService.setIsLoader(false);
        const toastMessage = Exception.exceptionMessage(e);
        this.toasterService.showError(toastMessage.join(', '), 'full');
      },
    });
  }

  toggleStatus(row: any, statusToggle: HTMLInputElement) {
    this.notificationService.setNotificationRow(row);
    if (
      row.distributionList == null ||
      !row.distributionList.emailCount ||
      row.distributionList.emailCount < 1
    ) {
      statusToggle.checked = false;
      this.modalService.open(this.noEmailsModal);
    } else {
      if (row?.status.toLowerCase() == 'default') this.subscribeDefaultNotification(row);
      else this.subscribeAllyNotification(row);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(); // Triggers takeUntil
    this.destroy$.complete(); // Final cleanup
  }
}
